<template>
  <div class="more-tools">
    <div class="inner">
      <div class="child">
        <div class="img">
          <img src="../../assets/images/icons/newhome/select_1.png" />
        </div>
        <div class="title">{{ $t("shortenTimeToMarket") }}</div>
        <div class="desc">{{ $t("quickProductUpdates") }}</div>
      </div>
      <div class="child">
        <div class="img">
          <img src="../../assets/images/icons/newhome/select_2.png" />
        </div>
        <div class="title">{{ $t("reduceShootingCosts") }}</div>
        <div class="desc">
          {{ $t("saveTraditionalCosts") }}
        </div>
      </div>
      <div class="child">
        <div class="img">
          <img src="../../assets/images/icons/newhome/select_3.png" />
        </div>
        <div class="title">{{ $t("boostSalesConversion") }}</div>
        <div class="desc">
          {{ $t("stayAheadOfCompetitors") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhySelect",
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  beforeDestroy() {},
};
</script>

<style scoped lang="less">
.more-tools {
  .inner {
    width: 1440px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .child {
      flex: 1;
      margin: 0 9px;
      background: rgba(136, 115, 255, 0.06);
      border-radius: 26px;
      .img {
        padding-top: 50px;
        padding-bottom: 22px;
        text-align: center;
        img {
          width: 73px;
        }
      }
      .title {
        font-size: 23px;
        font-family: GothamMedium;
        font-weight: 600;
        color: #000000;
        line-height: 33px;
        text-align: center;
        margin-bottom: 12px;
      }

      .desc {
        width: 225px;
        font-size: 15px;
        font-family: GothamMedium;
        font-weight: 500;
        color: #666666;
        line-height: 23px;
        text-align: center;
        margin: 0 auto;
        margin-bottom: 29px;
      }
    }
  }
}

/* 小于等于1440px时应用的样式 */
@media (max-width: 1440px) {
  .more-tools {
    .inner {
      width: 1200px;
    }
  }
}
</style>
